import React, { useState } from 'react';
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography,
} from '@material-ui/core';
import Layout from 'components/Layout/Layout';
import { UserService } from 'services/User/UserService';
import PageTitle from '../../../components/PageTitle/PageTitle';
import BrokenLinks from '../components/BrokenLinks';

export default function SitePages() {
  const [siteFilter, setSiteFilter] = useState<string>('');
  const [selectedSite, setSelectedSite] = useState<{
    domain: string;
    siteId: string;
  }>({
    domain: '',
    siteId: '',
  });
  const sites = UserService.useSitesWithIdAndDomainFromAccess();

  const handleChangeSiteFilter = (
    event: React.ChangeEvent<{ value: unknown }>,
  ) => {
    const selectedDomain = event.target.value as string;
    setSiteFilter(selectedDomain);
    const site = sites.find((s) => s.domain === selectedDomain) || {
      domain: '',
      siteId: '',
    };
    setSelectedSite(site);
  };

  return (
    <Layout>
      <Grid container spacing={0}>
        <Grid item xs={2}>
          <PageTitle title="Site Compliance" />
        </Grid>
        <Grid item xs={5} />
        <Grid item xs={5}>
          <Paper style={{ padding: '12px', backgroundColor: '#fff' }}>
            <FormControl fullWidth>
              <InputLabel id="site-select-label" shrink>
                Select Site
              </InputLabel>
              <Select
                labelId="site-select-label"
                id="site-select"
                value={siteFilter}
                onChange={handleChangeSiteFilter}
              >
                <MenuItem value="" disabled>
                  <em>Select an option</em>
                </MenuItem>
                {sites.map((site) => (
                  <MenuItem key={site.siteId} value={site.domain}>
                    {site.domain}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Paper>
        </Grid>
      </Grid>
      <div style={{ marginTop: '12px' }}>
        {!siteFilter ? (
          <Grid
            container
            component="div"
            style={{
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <Paper style={{ padding: '16px', width: '100%' }}>
              <Typography variant="h6" color="textSecondary">
                Please select a site to display compliance information.
              </Typography>
            </Paper>
          </Grid>
        ) : (
          <BrokenLinks data={selectedSite} />
        )}
      </div>
    </Layout>
  );
}
